// extracted by mini-css-extract-plugin
export default {"p":"_2002495ff4 _686fa71b97 ee1b948cc3","clr":"_03a8c40d28","dls":"_629805957c"};